// src/router/index.js - Vercel対応版
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Blog from '../views/Blog.vue'
import BlogDark from '../views/BlogDark.vue'
import BlogDetails from '../views/SingleBlog.vue'
import BlogDetailsDark from '../views/SingleBlogDark.vue'
import NewsDetail from '../views/NewsDetail.vue'
import NewsList from '../views/NewsList.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/blogs',
    name: 'Blogs',
    component: Blog
  },
  {
    path: '/blogs-dark',
    name: 'BlogsDark',
    component: BlogDark
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/blog-details/:id',
    name: 'BlogDetails',
    component: BlogDetails
  },
  {
    path: '/blog/:id',
    name: 'BlogDetailsAlias',
    component: BlogDetails
  },
  {
    path: '/blog-details-dark/:id',
    name: 'BlogDetailsDark',
    component: BlogDetailsDark
  },
  {
    path: '/news',
    name: 'NewsList',
    component: NewsList
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/news/:id',
    name: 'NewsDetails',
    component: NewsDetail
  },
  
  // 管理者用ルート - 遅延読み込みに変更
  {
    path: '/admin/news/login',
    name: 'NewsLogin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/NewsLogin.vue')
  },
  {
    path: '/admin/news',
    name: 'NewsAdmin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/NewsAdmin.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news/create',
    name: 'NewsCreate',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/NewsEditor.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news/edit/:id',
    name: 'NewsEdit',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/NewsEditor.vue'),
    meta: { requiresAuth: true }
  },
  
  // フォールバックルート
  {
    path: '/about',
    redirect: '/'
  },
  {
    path: '/portfolio',
    redirect: '/'
  },
  {
    path: '/portfolio/:id',
    redirect: '/'
  },
  {
    path: '/contact',
    redirect: '/'
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ルートガード - エラーハンドリング改善
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    try {
      // 動的インポートでstoreを取得
      const { default: store } = await import('../store')
      
      // newsモジュールが存在しない場合は動的に追加
      if (!store.hasModule('news')) {
        try {
          const newsModule = await import('../store/modules/news.js')
          store.registerModule('news', newsModule.default)
        } catch (moduleError) {
          console.error('Failed to load news module:', moduleError)
          next('/admin/news/login')
          return
        }
      }
      
      const isAuth = await store.dispatch('news/checkAuth')
      if (!isAuth) {
        next('/admin/news/login')
      } else {
        next()
      }
    } catch (error) {
      console.error('Auth check error:', error)
      next('/admin/news/login')
    }
  } else {
    next()
  }
})

export default router